export default "__VITE_ASSET__Bq29aHdK__"